import { getCalculatePercentileAction, getEditApplicationAction, getRejectApplicationAction } from './shared';
import type { CreateApplicationStageConfig } from './types';

export const createOfferStageConfig: CreateApplicationStageConfig = actions => ({
  badge: { id: 'offer', label: 'Offer', color: 'info' },
  getAttributes: () => [],
  getActions: () => [
    getRejectApplicationAction(actions),
    getEditApplicationAction(actions),
    getCalculatePercentileAction(actions),
  ],
  getActiveProcessesProps: () => ({
    collapsible: false,
    items: [
      {
        id: 'manage-offer',
        title: 'Manage offer',
        action: { id: 'review-offer', label: 'Review offer', variant: 'contained', onClick: actions.reviewOffer },
      },
    ],
  }),
});
